import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import Select from 'react-select';

class ReadyShortLists extends Component {

    constructor(props) {
        super(props);

    }
    componentDidMount() {
        // This method is called when the component is first added to the document

        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        this.ensureDataFetched();
    }

    ensureDataFetched() {
     //   const shortlistID = this.props.match.params.shortlistID;
        // this.props.requestWeatherForecasts(startDateIndex);
   //     this.props.getShortList(shortlistID);
        this.props.requestShortList(true,"");

    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    moveSingleTrack(e) {
        var asset = this.props.tempShortList.filter(t => t.code == e.dataTransfer.getData("text"));
        if (asset != null) {
            this.props.AddSingeAssetToShortList(asset[0]);
        }
    }

    selectTrack(e) {

      //  var track = this.props.assetSearchList.filter(a => a.code == e.target.value);
        this.props.selectTrack(e.target.value);
    }

    goUp(data) {

        let index;
        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }


        let items = this.reorder(
            this.props.tempShortList,
            index,
            index == 0 ? 0 : index - 1
        );
        console.info(items);

        this.props.sortTempTracks(items);
      //  this.props.updateShortList();
    }

    goDown(data) {

        let index;

        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }

        let items = this.reorder(
            this.props.tempShortList,
            index,
            index === this.props.tempShortList.length - 1 ? index : index + 1
        );
        console.info(items);

        this.props.sortTempTracks((items));
        //this.props.updateShortList();
    }

    onDragStart(e, id) {
        console.info(e + id);
        e.dataTransfer.setData("text", id);
    }

    onDragEnd(result) {
        console.info(result);
        if (!result.destination) {
            console.info("houston");
            return;
        }

        console.info(result.source.index);
        console.info(result.destination.index);
        let items = this.reorder(
            this.props.tempShortList,
            result.source.index,
            result.destination.index == -1 ? 0 : result.destination.index
        );
        console.info(items);

        this.props.sortTempTracks(items);
       // this.props.updateShortList();

    }

   

    renderShortListItems() {
        let data;

        if (this.props.shortlistDetailReady != null) {
            data = this.props.shortlistDetailReady.assets;
        }
       



        return <table onDragOver={(e) => e.preventDefault()} onDrop={(e) => this.moveSingleTrack(e)} className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>ISRC</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                    <th>Audio</th>
                    <th>version</th>
                    <th>LoP</th>
                    <th>Use</th>                  
                </tr>
            </thead>
            <tbody>
                {
                    this.props.shortlistDetailReady ? data.map((product, index) =>
                        <tr key={product.code}>
                            <td>{index + 1}</td>
                            <td>{product.isrc}</td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>
                            <td> <button onClick={() => this.props.setAudioUrl(product.fugaID)}> {this.props.audioURL === product.fugaID ? "Playing" : "Play"}</button> </td>
                            <td>{product.version}</td>
                            <td>{product.lop === "ZXX" ? "Ins" : product.lop}</td>
                            <td>{product.productCount == 0 ? "Inactive" : product.productCount < 5 ? "Active" : "Hyper"}</td>
                           

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }
    renderForecastsTable() {
        let data;
        data = this.props.tempShortList;
        return <table className='table table-hover search'>
            <thead>
                <tr>
                    <th>#</th>
                    <th>ISRC</th>
                    <th>Catalog</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Genre</th>
                    <th>Sub Genre</th>
                    <th>Audio</th>                   
                    <th>version</th>                   
                    <th>LoP</th>                   
                    <th>Use</th>
                    <th></th>
                    <th></th>
                    <th>Short Listed</th>
                </tr>
            </thead>
            <tbody>
                {
                    !this.props.isLoadingSearchList ? data.map((product, index) =>
                        <tr draggable onDragStart={(e) => this.onDragStart(e, product.isrc)} onDragEnd={(e) => this.onDragEnd(e, product.isr)} onDragOver = {(e) => e.preventDefault()} key={product.isrc}>
                            <td>{index+1}</td>
                            <td>{product.isrc}</td>
                            <td>{product.catalog}</td>
                            <td>{product.name}</td>
                            <td>{product.displayArtist}</td>
                            <td>{product.genre}</td>
                            <td>{product.subGenre}</td>
                            <td> <button onClick={() => this.props.setAudioUrl(product.fugaID)}> {this.props.audioURL === product.fugaID ? "Playing" : "Play"}</button> </td>                          
                            <td>{product.version}</td>                          
                            <td>{product.lop == "ZXX" ? "Ins" : product.lop}</td>                         
                            <td>{product.productCount == 0 ? "Inactive" : product.productCount < 5 ? "Active" : "Hyper"}</td>
                            <td><span className='glyphicon glyphicon-arrow-up' value={index} onClick={() => this.goUp(index)} >up</span></td>
                            <td><span className='glyphicon glyphicon-arrow-down' value={index} onClick={() => this.goDown(index)}>down</span></td>
                            <td><button className='btn btn-default' value={product.isrc} onClick={this.selectTrack.bind(this)}> {this.props.tempShortList.filter(t => t.isrc === product.isrc).length > 0 ? '√' : 'X'} </button></td>

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }

    createShortList(e) {
        this.props.CreateShortList();
    }

    selectAndShow(data) {

        this.props.SetShortlist(data,true);
        if (data !== null) {
            this.props.requestShortListDetailDraft(true);
            this.props.requestShortListAnalysis(true);
        } else {
          //  this.props.ClearShortListDetail();
        }

    }

     renderShortlistAnalysis() {
        var catalog = this.props.shortlistAnalysisReady;
        const toHHMMSS = (secs) => {
            var sec_num = parseInt(secs, 10)
            var hours = Math.floor(sec_num / 3600) % 24
            var minutes = Math.floor(sec_num / 60) % 60
            var seconds = sec_num % 60
            return [hours, minutes, seconds]
                .map(v => v < 10 ? "0" + v : v)
                .filter((v, i) => v !== "00" || i > 0)
                .join(":")
        }
        if (this.props.isLoadingShortListAnalysis) {
            return <div>Loading...</div>
        } else {
            return (<dl className="dl-horizontal">
                <dt>Number of tracks</dt>
                <dd>{catalog.numberTracks}</dd>
                <dt>Tracks duration</dt>
                <dd>{toHHMMSS(catalog.totalDuration)}</dd>
                <dt>Public Domain</dt>
                <dd>{catalog.pd ? 'Yes' : 'No'}</dd>                
                <dt>Type of Product</dt>
                <dd>{catalog.typeOfProduct}</dd>
                <dt>Note</dt>
                <dd>{catalog.warning}</dd>
            </dl>)
        }
    }

    modifyShortList() {
        this.props.ModifyShortList();

    }

    setProductState(state) {
       
        this.props.setListReady(this.props.selectedShortlistReady.value, state);

    }

    render() {
        const access = localStorage.getItem("accessToken");
        console.info(this.props.shortLists);
        let url = this.props ? this.props.audioURL : '';
        return (
            <div>
                <h1>Products</h1>
                <table className="shortlist-table">
                    <tbody>
                        <tr>
                            <td>  <Select
                                isLoading={this.props.isLoadingShortlists}
                                name="form-field-name"
                                value={this.props.selectedShortlistReady}
                                options={this.props.shortListsReady}
                                multi={false}
                                onChange={(data) => this.selectAndShow(data)}
                                disabled={this.props.isLoadingShortlists}
                            />
                            </td>
                           
                            
                        </tr>    
                        <tr>
                            <td>
                             
                                <button style={{ "margin": "10px" }} disabled={this.props.shortlistDetailReady ? false : true} onClick={() => this.setProductState("Amend")}>Amend</button>
                                <button style={{ "margin": "10px" }} disabled={this.props.shortlistDetailReady ? false : true} onClick={() => this.setProductState("Approved")}>Approved</button>
                               
                            </td>

                        </tr>    
                        
                    </tbody>
                </table>


                {this.props.shortlistAnalysisReady != null ? this.renderShortlistAnalysis() : 'no data'}
                {this.renderShortListItems()}
              

            </div>
              
        );
    }
}








export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(ReadyShortLists);



// WEBPACK FOOTER //
// ./src/components/ReadyShortlists.js